module.exports = "<div>\n    <!-- このDOMノード下に背景地図一覧が入る -->\n    <div data-dojo-attach-point=\"layerListContainer\"></div>\n</div>\n"